var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"55BA29D0-6C42-41B9-AC87-1F7B2076B7A4"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("g",{"id":"Atc-ventures-v1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Atc-Ventures---v1","transform":"translate(-715.000000, -4756.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Group-5","transform":"translate(715.000000, 4748.000000)"},React.createElement("circle",{"id":"Oval","cx":"7.5","cy":"15.5","r":"7.5"}))))]);
}

Oval.defaultProps = {"width":"15px","height":"15px","viewBox":"0 0 15 15","version":"1.1"};

module.exports = Oval;

Oval.default = Oval;
